import { render, staticRenderFns } from "./RepresentativeStatute.vue?vue&type=template&id=15790bfd&"
import script from "./RepresentativeStatute.vue?vue&type=script&lang=ts&"
export * from "./RepresentativeStatute.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports